<template>
  <div class="bg--white">
    <SetupCanvas ref="setupCanvasChild" :msg="pathwayName" :sk=true />
  </div>
</template>

<script>
// @ is an alias to /src
import SetupCanvas from "@/components/SetupCanvas.vue";

export default {
  name: "home",
  components: {
    SetupCanvas
  },
  data() {
    return {
      pathwayName: "Create Pathway"
    };
  },
  mounted() {
    var self = this;
    this.$root.$on("savePathwayName", function(n) {
      if (n.length > 0) self.pathwayName = n;
      else self.pathwayName = "Create Pathway";
    });
  }
};
</script>
